import { motion } from "framer-motion";
import { EN, RAINBOW_ORDER, SECTIONS } from "../lib/sections";
import { hallPrompt } from "../lib/copy";

const PUB = process.env.PUBLIC_URL || "";
// The Feeling Wall painted flat, for a phone whose 3D hall could not run twice: the five doors, each opening its room
export default function Hall2D({ onDoor }) {
  return (
    <div data-testid="hall-2d" className="absolute inset-0 flex flex-col items-center overflow-y-auto bg-[#EBDDF7]" style={{ backgroundImage: `radial-gradient(ellipse at 50% 18%, rgba(255,247,236,0.9), rgba(235,221,247,0) 62%), url(${PUB}/landing/ink-bloom.webp)`, backgroundSize: "cover", backgroundPosition: "center" }}>
      <p data-testid="hall-2d-prompt" className="mt-36 rounded-full bg-[#FBF7F2]/90 px-5 py-2 text-center font-display text-xl italic text-[#2D1E3E] sm:mt-24 sm:text-2xl">
        {hallPrompt()}
      </p>
      <div className="mt-8 flex w-full max-w-4xl flex-wrap items-end justify-center gap-x-4 gap-y-8 px-6 pb-28">
        {RAINBOW_ORDER.map((id, i) => (
          <motion.button
            key={id}
            data-testid={`hall-2d-door-${id}`}
            onClick={() => onDoor(id)}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 * i, duration: 0.5 }}
            whileHover={{ y: -4 }}
            className="group flex w-[38vw] max-w-[150px] flex-col items-center"
          >
            <span className="relative block h-[30vw] max-h-[190px] w-full overflow-hidden rounded-t-full border-[3px] border-[#5A3E2B]/70 shadow-[0_20px_30px_-18px_rgba(45,30,62,0.6)]" style={{ background: `radial-gradient(ellipse at 50% 85%, ${SECTIONS[id].glow}cc, ${SECTIONS[id].tint} 55%, #3A2650 125%)` }}>
              <span className="absolute inset-x-[18%] bottom-0 top-[22%] rounded-t-full bg-[#FFF6E8]/25 transition-opacity duration-300 group-hover:opacity-60" />
            </span>
            <span className="mt-2 font-display text-lg italic text-[#2D1E3E]">{SECTIONS[id].name}</span>
            <span className="text-xs tracking-wide text-[#5C4A72]">{EN[id]}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
